import { useState } from "react";
import Colors from "assets/Colors.js";
import { Radio, Space } from "antd";
import PhoneInput from "react-phone-number-input";
import es from "react-phone-number-input/locale/es";
import Input from "components/common/Input";
import ColorSelector from "components/common/ColorSelector";
import ImageIcon from "components/icons/ImageIcon";
import ToggleSwitch from "components/common/ToggleSwitch";
import { useTranslation } from "react-i18next";
import s from "../../../../styles/GeneralBody.styles";

function GeneralBody({
  randomNumber,
  getFieldProps,
  values,
  setFieldValue,
  setFieldTouched,
  errors,
  touched,
}) {
  const { t } = useTranslation();
  const [rol, setRol] = useState(values.roles[0]);
  const [num, setNum] = useState("");

  const onChange = (e) => {
    setRol(e.target.value);
    setFieldValue("roles", e.target.value);
  };

  const handleNumChange = (event) => {
    const limit = 4;
    setNum(event.target.value.slice(0, limit));
    setFieldValue("pin", event.target.value.slice(0, limit) || num);
  };

  return (
    <s.TopSectionsContainer
      style={{
        display: "flex",
      }}
    >
      {/* start left contend */}
      <s.LeftContainer>
        <s.SectionTitle style={{ marginBottom: "18px" }}>
          {t("components.EmployeesList.AddWorker.GeneralBody.addWorker")}
        </s.SectionTitle>

        <s.Line style={{ marginBottom: "10px" }} />

        <s.gridInputContainer>
          <s.InputContainer>
            <s.SubTitle>{t("Users.fields.name.label")}*</s.SubTitle>
            <Input
              valid={touched.name && errors.name}
              placeholder={t("Users.fields.name.placeholder")}
              {...getFieldProps("name")}
            />
            {touched.name && errors.name && (
              <s.messageAlert style={{ marginBottom: "-32px" }}>
                {t("formValidations.required")}
              </s.messageAlert>
            )}
          </s.InputContainer>

          <s.InputContainer>
            <s.SubTitle>{t("Users.fields.lastName.label")}</s.SubTitle>
            <Input
              valid={touched.lastName && errors.lastName}
              placeholder={t("Users.fields.lastName.placeholder")}
              {...getFieldProps("lastName")}
            />
            {touched.lastName && errors.lastName && (
              <s.messageAlert style={{ marginBottom: "-21px" }}>
                {t("formValidations.required")}
              </s.messageAlert>
            )}
          </s.InputContainer>
          <s.InputContainer
            style={{
              marginTop: "27px",
            }}
          >
            <s.SubTitle>{t("Users.fields.email.label")}</s.SubTitle>
            <Input
              placeholder={t("Users.fields.email.placeholder")}
              valid={touched.email && errors.email}
              {...getFieldProps("email")}
            />
            {touched.email && errors.email && (
              <s.messageAlert style={{ marginBottom: "-32px" }}>
                {t("formValidations.required")}
              </s.messageAlert>
            )}
          </s.InputContainer>
          <s.InputContainer
            style={{
              marginTop: "27px",
            }}
          >
            <s.SubTitle>{t("Users.fields.phone.label")}</s.SubTitle>
            <PhoneInput
              labels={es}
              international={false}
              placeholder={t("Customers.fields.phone.placeholder")}
              defaultCountry="ES"
              value={values.phone}
              onChange={(value) => [
                setFieldValue("phone", value),
                setFieldTouched("phone", value),
              ]}
            />
            {/* <Input
              placeholder={t("Users.fields.phone.placeholder")}
              {...getFieldProps("phone")}
            /> */}
          </s.InputContainer>
        </s.gridInputContainer>

        <s.Line style={{ marginTop: "42px", marginBottom: "14px" }} />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {t("Users.fields.disabled.message")}
          <ToggleSwitch
            checked={values.disabled}
            name="disabled"
            onChange={(value) => setFieldValue("disabled", value)}
          />
        </div>
        <s.Line style={{ marginTop: "13px" }} />

        <s.SectionTitle style={{ marginBottom: "18px", marginTop: "59px" }}>
          {t("components.EmployeesList.AddWorker.GeneralBody.workerAddress")}
        </s.SectionTitle>
        <s.Line style={{ marginBottom: "10px" }} />

        <s.gridInputContainer>
          <s.InputContainer>
            <s.SubTitle>{t("Users.fields.address1.label")}</s.SubTitle>
            <Input
              placeholder={t("Users.fields.address1.placeholder")}
              style={{
                marginBottom: "27px",
              }}
              {...getFieldProps("address1")}
            />
          </s.InputContainer>

          <s.InputContainer>
            <s.SubTitle>{t("Users.fields.address2.label")}</s.SubTitle>
            <Input
              placeholder={t("Users.fields.address2.placeholder")}
              style={{
                marginBottom: "10px",
              }}
              {...getFieldProps("address2")}
            />
          </s.InputContainer>
          <s.InputContainer>
            <s.SubTitle>{t("Users.fields.city.label")}</s.SubTitle>
            <Input
              style={{
                marginBottom: "10px",
              }}
              placeholder={t("Users.fields.city.placeholder")}
              {...getFieldProps("city")}
            />
          </s.InputContainer>
          <s.InputContainer>
            <s.SubTitle>{t("Users.fields.country.label")}</s.SubTitle>
            <Input
              style={{
                marginBottom: "10px",
              }}
              placeholder={t("Users.fields.country.placeholder")}
              {...getFieldProps("country")}
            />
          </s.InputContainer>
        </s.gridInputContainer>

        <s.SectionTitle style={{ marginBottom: "18px", marginTop: "74px" }}>
          {t("components.EmployeesList.AddWorker.GeneralBody.accessUser")}
        </s.SectionTitle>
        <s.Line style={{ marginBottom: "10px" }} />

        <s.gridInputContainer>
          <s.InputContainer>
            <s.SubTitle>{t("Users.fields.pin.label")}*</s.SubTitle>
            <Input
              style={{
                marginBottom: "27px",
              }}
              valid={errors.pin}
              type="number"
              value={values.pin}
              placeholder={values.pin == "" ? "1234" : "****"}
              onChange={handleNumChange}
            />
            {errors.pin && (
              <s.messageAlert style={{ marginTop: "-21px" }}>
                {t("formValidations.required")}
              </s.messageAlert>
            )}
          </s.InputContainer>

          <s.InputContainer>
            <s.SubTitle>ㅤ</s.SubTitle>
            <s.buttonPin onClick={() => setFieldValue("pin", randomNumber())}>
              {t("Users.fields.pin.pinButton")}
            </s.buttonPin>
          </s.InputContainer>
        </s.gridInputContainer>
      </s.LeftContainer>

      {/* Start right content */}
      <s.RightContainer>
        <s.SectionTitle style={{ marginBottom: "18px" }}>
          {t(
            "components.EmployeesList.AddWorker.GeneralBody.workerVisualization"
          )}
        </s.SectionTitle>
        <s.PhotoSectionMiddle>
          <s.ImageContainer style={{ background: values.color }}>
            {!values.color && <ImageIcon />}
          </s.ImageContainer>
          <s.TextImageContainer>
            <div style={{ marginBottom: "16px" }}>
              {t("imagePicker.addImage")}
            </div>
            <div>{t("imagePicker.takeAPicture")}</div>
          </s.TextImageContainer>
        </s.PhotoSectionMiddle>
        <s.LittleMessage style={{ marginTop: "13px", marginBottom: "18px" }}>
          {t("imagePicker.message")}
        </s.LittleMessage>
        <s.SubTitle style={{ marginBottom: "13px" }}>
          {t("imagePicker.selectColor")}
        </s.SubTitle>
        <ColorSelector
          handleChange={(value) => setFieldValue("color", value)}
        />

        <s.SectionTitle style={{ marginBottom: "18px", marginTop: "81px" }}>
          {t("components.EmployeesList.AddWorker.GeneralBody.security")}
        </s.SectionTitle>
        <s.Line style={{ marginBottom: "10px" }} />
        <s.SubTitle style={{ marginBottom: "8px" }}>
          {t("Users.fields.roles.label")}*
        </s.SubTitle>

        <Radio.Group disabled={rol == "root"} onChange={onChange} value={rol}>
          <Space direction="vertical" size={9}>
            <s.groupRadio
              color={rol == "admin" ? Colors.background_blurry : "#fff"}
            >
              <Radio value="admin">{t("Users.fields.roles.admin")}</Radio>
            </s.groupRadio>
            <s.groupRadio
              color={rol == "manager" ? Colors.background_blurry : "#fff"}
            >
              <Radio value="manager">{t("Users.fields.roles.manager")}</Radio>
            </s.groupRadio>
            <s.groupRadio
              color={rol == "clerk" ? Colors.background_blurry : "#fff"}
            >
              <Radio value="clerk">{t("Users.fields.roles.clerk")}</Radio>
            </s.groupRadio>
            <s.groupRadio
              color={rol == "no_tpv" ? Colors.background_blurry : "#fff"}
            >
              <Radio value="no_tpv">
                {t("Users.fields.roles.noAccessToPOS")}
              </Radio>
            </s.groupRadio>
            <s.groupRadio
              color={rol == "delivery" ? Colors.background_blurry : "#fff"}
            >
              <Radio value="delivery">{t("Users.fields.roles.delivery")}</Radio>
            </s.groupRadio>
          </Space>
        </Radio.Group>
      </s.RightContainer>
    </s.TopSectionsContainer>
  );
}

export default GeneralBody;
